import { Injectable } from '@angular/core';
import { BzgToastService } from 'bz-genome-angular';
import { BzgToastRef } from 'bz-genome-angular/toast/toast.ref';

@Injectable({
  providedIn: 'root'
})
export class MessageService {

  constructor(private toastService: BzgToastService) {

  }
  messages: string[] = [];

  showError(message: string) {
    this.toastService.open(message, {
      type: 'error',
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showMessage(message: string): BzgToastRef {
    const toastRef = this.toastService.open(message, {
      type: "success",
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "right"
    });
    return toastRef;
  }

  add(message: string) {
    this.messages.push(message);
  }

  clear() {
    this.messages = [];
  }

  showSuccess(message: string) {
    this.toastService.open(message, {
      type: "success",
      duration: 5000,
      verticalPosition: "top",
      horizontalPosition: "right"
    });
  }
}
